import Head from 'next/head';
import React from 'react';

interface AppHeadProps {
  title: string;
}

export default function AppHead({ title }: AppHeadProps): JSX.Element {
  return (
    <Head>
      <title>{`${title} - NomadMD`}</title>
    </Head>
  );
}
